import { useQuery } from '@tanstack/react-query';
import { getLearnerReferralLink, getLearnerReferrals } from './api';

const FIVE_MINUTES = 5 * 60 * 1000;

/** The learner's invite link and the live bonus amounts. */
export function useLearnerReferralLink() {
  return useQuery({
    queryKey: ['learner-referrals', 'link'],
    queryFn: ({ signal }) => getLearnerReferralLink(signal),
    staleTime: FIVE_MINUTES,
    retry: false,
  });
}

export function useLearnerReferrals() {
  return useQuery({
    queryKey: ['learner-referrals', 'list'],
    queryFn: ({ signal }) => getLearnerReferrals(signal),
    retry: false,
  });
}
